import React from 'react'
import { Tag, Tooltip } from '@surecompanies/core_components'
import {
  PAYMENT_ASSIGNMENT_STATUS_LABELS,
  PaymentAssignmentStatusId,
} from './Utils/types'
import { getPaymentStatusColor } from './payment-assignment.style'

interface PaymentStatusTagProps {
  statusId?: PaymentAssignmentStatusId
  onClick?: () => void
}

export const PaymentStatusTag: React.FC<PaymentStatusTagProps> = ({
  statusId,
  onClick,
}) => {
  const statusLabel = PAYMENT_ASSIGNMENT_STATUS_LABELS[statusId ?? ''] || '—'
  const isBotActive = [
    PaymentAssignmentStatusId.BOT_PROCESSING,
    PaymentAssignmentStatusId.BOT_QUEUED,
  ].includes(statusId as PaymentAssignmentStatusId)
  const displayLabel = isBotActive ? `⏳ ${statusLabel}` : statusLabel

  return (
    <Tag
      color={getPaymentStatusColor(statusId)}
      style={{ cursor: 'pointer' }}
      onClick={(e) => {
        e.stopPropagation()
        onClick?.()
      }}
    >
      <Tooltip placement="topLeft" title={statusId}>
        {displayLabel}
      </Tooltip>
    </Tag>
  )
}
